import { render, staticRenderFns } from "./Qi.vue?vue&type=template&id=f30fb550&scoped=true&"
import script from "./Qi.vue?vue&type=script&lang=js&"
export * from "./Qi.vue?vue&type=script&lang=js&"
import style0 from "./Qi.vue?vue&type=style&index=0&id=f30fb550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30fb550",
  null
  
)

export default component.exports